









































// @ts-nocheck

import Vue from 'vue';
import { sanityClient, urlFor } from '@/config/sanity';
import Story from '@/models/story';
import LoadingIndicator from '@/components/LoadingIndicator.vue';
import ErrorMessage from '@/components/ErrorMessage.vue';
import SanityBlockContent from '@/components/SanityBlockContent.vue';
import SanityMarkdownContent from '@/components/SanityMarkdownContent.vue';
import EmployeePortrait from '@/components/EmployeePortrait.vue';
import SpeakerWithGradient from '@/components/SpeakerWithGradient.vue';
import {
  parseDateTimeFromSanityAutoGeneratedTimestamp,
  parseDateTimeFromSanityInputField,
  formatToLongDisplayFormat,
} from '@/utils/date';

interface Data {
  isLoading: boolean;
  error: string;
  story: Story | null;
  meta: Record<string, string>;
}

export default Vue.extend({
  name: 'Story',
  components: {
    LoadingIndicator,
    ErrorMessage,
    SanityBlockContent,
    EmployeePortrait,
    SpeakerWithGradient,
    SanityMarkdownContent,
  },
  data(): Data {
    return {
      isLoading: true,
      error: '',
      story: null,
    };
  },
  created() {
    this.fetchStory();
  },
  methods: {
    urlFor,
    fetchStory() {
      this.isLoading = true;
      const query = `*[slug.current == $slug]{
        "createdAt": _createdAt,
        "updatedAt": _updatedAt,
        "id": _id,
        "key": _key,
        "slug": slug.current,
        isListed,
        lang,
        title,
        excerpt,
        image,
        author->{name,image,department,title},
        content,
        markdownContent,
        department,
        publishedDate,
        updatedDate,
        facebookQuote,
        facebookHashtag,
        twitterHashtags,
        twitterVia,
        emailSubject,
        emailBody,
      }[0]`;

      const params = { slug: this.$route.params.storySlug };
      return sanityClient.fetch(query, params).then(
        (results) => {
          const createdAt = parseDateTimeFromSanityAutoGeneratedTimestamp(results.createdAt);
          const createdAtFormatted = formatToLongDisplayFormat(createdAt);
          const updatedAt = parseDateTimeFromSanityAutoGeneratedTimestamp(results.updatedAt);
          const updatedAtFormatted = formatToLongDisplayFormat(updatedAt);
          const publishedDate = parseDateTimeFromSanityInputField(results.publishedDate);
          const publishedDateFormatted = formatToLongDisplayFormat(publishedDate);
          const updatedDate = parseDateTimeFromSanityInputField(results.updatedDate);
          const updatedDateFormatted = formatToLongDisplayFormat(updatedDate);
          const story = {
            ...results,
            createdAt,
            createdAtFormatted,
            updatedAt,
            updatedAtFormatted,
            publishedDate,
            publishedDateFormatted,
            updatedDate,
            updatedDateFormatted,
          };

          this.story = story;
          console.log('this.story', this.story);
          this.isLoading = false;
        },
        (error) => {
          this.error = error;
          this.isLoading = false;
        },
      );
    },
  },
});
